<template>
	<no-ssr>
		<div v-if="(!userSubscribed || (userSubscribed && allowDisplayLoggedIn)) && !isPortal" ref="adContainer">
			<span v-if="showBaseOnViewPortSize">
				<script type="application/javascript">
					googletag.cmd.push(function () {
						googletag.pubads().enableAsyncRendering();
						googletag.pubads().enableLazyLoad(
							{ fetchMarginPercent: 300, renderMarginPercent: 200, mobileScaling: 2.0 }
						);
						googletag.pubads().collapseEmptyDivs();

						if ('{{responsive}}'){
							if('{{adUnit}}' == "savingforcollege_feature_story_box"){
								// Ad sizes for featured story in the homepage
								var mapping = googletag.sizeMapping().
									addSize([1270, 0], [1120, 362]).
									addSize([1044, 0], [942, 352]).
									addSize([744, 0], [659, 352]).
									addSize([375, 0], [312, 647]).
									addSize([0,0], [200, 215]).
									build();
							}

							if('{{adUnit}}' == "savingforcollege_hello_bar"){
								// Ad sizes for hello bar
								var mapping = googletag.sizeMapping().
									addSize([1065, 0], [1065, 131]).
									addSize([925, 0], [925, 131]).
									build();
							}

							//Add more conditions for other responsive ads

							googletag.defineSlot('/4802340/{{adUnit}}', {{sizes}}, '{{randomAdUnit}}').
							defineSizeMapping(mapping).
							addService(googletag.pubads());

						}else{
							googletag.defineSlot('/4802340/{{adUnit}}', {{sizes}}, '{{randomAdUnit}}').addService(googletag.pubads());
						}

						googletag.enableServices();

						// Listener for rendered ads
						googletag.pubads().addEventListener('slotRenderEnded', function(event) {
							var slot = event.slot;
							var targetSlot = '/4802340/savingforcollege_feature_story_box';
							var adDiv = 'featured-story-ad';
							var currentWidth = document.documentElement.clientWidth;
							var marginBottom = "48px";
							if(slot.getAdUnitPath() === targetSlot) {
								if(currentWidth <= 765){
									marginBottom = "16px"
								}
								document.getElementById(adDiv).style.marginBottom = marginBottom;
							}

						});
					});
				</script>
				<aside :id="randomAdUnit">
					<script type="application/javascript">
						setTimeout(function(){
							googletag.cmd.push(function() { googletag.display('{{randomAdUnit}}'); });
						}, {{computedDelay}});
					</script>
				</aside>
			</span>
		</div>
	</no-ssr>
</template>

<style lang="stylus">
	.sfc-dfp-long
		div
			span
				aside
					background black
					div[id^='google_ads_iframe_']
						height auto !important

</style>

<script>
	// Example in pug: sfc-dfp-ad(ad-unit="savingforcollege_other_right_text_1" sizes="[[160,160],[300,80]]")
	export default {

		created() {
			this.randomNumber = Math.floor(Math.random()*10000000000)
		},

		computed: {
			randomAdUnit() {
				return `${this.adUnit}__${this.randomNumber}`
			},
			computedDelay(){
				if (this.delay) {
					return parseInt(this.delay);
				}
				return 100;
			},

			showBaseOnViewPortSize(){
				if(process.browser){
					const viewPortSize = document.documentElement.clientWidth

					const mobile = (this.mobile === true || this.mobile=="true")
					if(viewPortSize <= 660 && mobile){
						return true
					}

					if(viewPortSize > 660 && mobile){
						return false
					}

					if(viewPortSize > 660 && !mobile){
						return true
					}
				}

				if(this.responsive){
					return true
				}

				return false
			},
			isPortal(){
				return (this.$route.query.layout == "blank" && this.$route.query.portal)
			},
			userSubscribed(){
				return (this.$store.state.sfcSubscriptions && this.$store.state.sfcSubscriptions.subscription_order_id)
			}
		},

		props: [
			'adUnit',
			'sizes',
			'delay',
			'mobile',
			'responsive',
			'allowDisplayLoggedIn'
		],
		watch: {
			'$route': function (refreshPage) {
				setTimeout( () => {
					let currentTimeInMiliseconds = (new Date()).getTime()
					let timeSinceLastUpdate = currentTimeInMiliseconds - this.$store.state.lastAdsUpdate
					if(timeSinceLastUpdate >= 500){
						this.$store.commit('updateLastAdsUpdate', (new Date()).getTime())
						try{
							googletag.pubads().refresh()
						}catch(e){
						}
					}
				},0)
			}
		}
	}
</script>
